import React from 'react';

import { Virtual, Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import '../css/ourServices.css';
import 'swiper/css';
import 'swiper/css/navigation';

const OurServices = ({ data }) => {
  return (
    <section
      className="services py-md-5 lazy-bg skeleton loaded"
      data-bg="url(./images/types-of-training.png)"
      style={{
        backgroundImage: "url('/images/types-of-training.webp')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <h2 className="default-box-title text-center">
          HOẠT ĐỘNG NỔI BẬT CỦA HỘI CỰU SINH VIÊN
        </h2>
        <p>
          Với tinh thần gắn kết, chia sẻ và phát triển bền vững, Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ không ngừng tổ chức các hoạt động thiết thực,
          hướng đến cộng đồng và thế hệ kế thừa.
        </p>
        <Swiper
          modules={[Virtual, Navigation, Autoplay]}
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={30}
          navigation={true}
          virtual
          centeredSlides={false}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
        >
          {data.map((service, index) => (
            <SwiperSlide key={index} virtualIndex={index}>
              <div>
                <div className="text-center position-relative lazy-container">
                  <div
                    className="skeleton"
                    style={{ height: '300px', display: 'none' }}
                  ></div>

                  <img
                    data-src={service.imageUrl}
                    className="mw-100 lazy-img loaded img-thumbnail rounded-5"
                    alt=""
                    loading="lazy"
                    src={service.imageUrl}
                    style={{
                      width: '100%',
                      aspectRatio: '1/1',
                      objectFit: 'cover',
                    }}
                  />
                </div>

                <h3 className="text-center">{service.title}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="text-center mt-lg-5 mt-4">
          <span
            onClick={() =>
              document
                .getElementById('enrollment')
                ?.scrollIntoView({ behavior: 'smooth' })
            }
            className="btn"
            onclick="jump('enrollment-form')"
          >
            Liên hệ với chúng tôi
          </span>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
